/* @ngInject */
function AdminController ($scope, $rootScope, $state, $translate, ProductsFrameService) {
  const mMenuState = {
    1: { state: 'admin.users' },
    3: { state: 'admin.general' },
    4: { state: 'admin.groups' },
    5: { state: 'admin.campaigns' },
    6: { state: 'admin.postCategories' },
    7: { state: 'admin.backOffice' },
    9: { state: 'admin.auditBriefingNew' },
    10: { state: 'admin.auditBriefing' },
    11: { state: 'admin.accountManagement' },
    14: { state: 'admin.generalBackoffice' },
    15: { state: 'admin.tags' },
    16: { state: 'admin.formats' },
    17: { state: 'admin.integrations' },
    18: { state: 'admin.guests' },
    19: { state: 'admin.taskTags' },
    20: { state: 'admin.products' }
  }

  angular.element(document).ready(function () {
    // scroll to start of page
    $(document).scrollTop(0)
  })

  $scope.selectedMenuId = parseInt(Object.keys(mMenuState).find((menuId) => mMenuState[menuId].state === $state.current.name)) || 1

  $scope.handleMenuPress = function (iMenuId) {
    $scope.selectedMenuId = iMenuId

    const sState = mMenuState[iMenuId]
    $state.go(sState.state)
  }

  $scope.isSelectedMenuId = function (menuId) {
    return menuId === $scope.selectedMenuId
  }

  $scope.sectionHasActiveMenu = function (section) {
    return section.menus.filter(function (menu) {
      return menu.id === parseInt($scope.selectedMenuId)
    }).length > 0
  }

  $translate.onReady(function () {
    $scope.mSections = {}

    $rootScope.getUser().then(function (oUser) {
      if ($rootScope.isUserSysAdminAdmin(oUser)) {
        $scope.mSections.team = {
          title: $translate.instant('team'),
          menus: [
            {
              id: 1,
              title: $translate.instant('users')
            },
            {
              id: 4,
              title: $translate.instant('groups')
            }
          ],
          collapsed: true
        }

        Promise.all([
          $rootScope.getCompanyFeaturesAndAddons(),
          $rootScope.getCompanyFeatures()
        ]).then(([{ features }, companyFeatures]) => {
          if (features['SHARE.GUEST'] || companyFeatures.includes('GUEST_ASSET_PACK')) {
            $scope.mSections.team.menus.push({
              id: 18,
              title: $translate.instant('manageGuests.guests')
            })
          }
        })
      }
    })

    $rootScope.getCompanyFeaturesAndAddons().then(function ({ features }) {
      $rootScope.oCustomerCompanyConfigurations = features

      if (features['ARTS.ACCESS']) {
        $scope.mSections.arts = {
          title: $translate.instant('arts'),
          menus: [],
          collapsed: true
        }

        if ($rootScope.isUserSysAdminAdminDesigner()) {
          $scope.mSections.arts.menus.push({
            id: 15,
            title: $translate.instant('categoryFilterName')
          })
          $scope.mSections.arts.menus.push({
            id: 16,
            title: $translate.instant('products')
          })

          const hasProductFrameFeature = ProductsFrameService.hasFeature($rootScope.oUserCompanyFeatures)

          if (hasProductFrameFeature) {
            $scope.mSections.arts.menus.push({
              id: 20,
              title: $translate.instant('productFrame.title')
            })
          }
        }

        $scope.mSections.arts.menus.push({
          id: 5,
          title: $translate.instant('campaigns.title')
        })
      }

      if (features['WORKFLOW.ACCESS']) {
        $scope.mSections.requests = {
          title: $translate.instant('requests'),
          menus: [
            {
              id: 19,
              title: $translate.instant('tags')
            }
          ],
          collapsed: true
        }
      }

      if (features['POSTS.ACCESS']) {
        $scope.mSections.posts = {
          title: $translate.instant('posts'),
          menus: [
            {
              id: 6,
              title: $translate.instant('categories')
            }
          ],
          collapsed: true
        }
      }
    })

    $rootScope.getUser().then(function (oUser) {
      if ($rootScope.isUserSysAdminAdmin(oUser)) {
        $scope.mSections.settings = {
          title: $translate.instant('configurations'),
          menus: [
            {
              id: 11,
              title: $translate.instant('accountManagement')
            },
            {
              id: 3,
              title: $translate.instant('configurations')
            }
          ],
          collapsed: true
        }

        $rootScope.getCompanyFeatures().then((features) => {
          if (!features.includes('EXTERNAL_LOGIN_INTEGRATION')) return

          $scope.mSections.settings.menus.push({
            id: 17,
            title: $translate.instant('adminIntegrations.title')
          })
        })
      }

      if ($rootScope.isUserSysAdmin()) {
        $scope.mSections.backoffice = {
          title: $translate.instant('generalBackoffice.title'),
          menus: [
            {
              id: 7,
              title: $translate.instant('backoffice.title')
            },
            {
              id: 14,
              title: $translate.instant('generalBackoffice.title')
            }
          ],
          collapsed: true
        }
      }
    })
  })
}

export { AdminController }
